import React from "react"
import uuid from "uuid"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import { connect } from "react-redux"
import styled from "styled-components"
import Divider from "@material-ui/core/Divider"

import PageHeader from "../PageHeader"
import CarouselView from "../../components/carousel"
import ProgressBar from "../../components/ProgressBar"
import PrimaryButton from "../../components/buttons/PrimaryButton"
import { fetchData, removeData, showToast, showPopup } from "../../store/action"
//import { ToasterMsg } from "../../site-settings";
import { replaceWithSymbol } from "../../util/cutString"
import config from "../../Config"
import { isUser } from "../../util/CheckUser"
import { event } from "../../components/reactGA"
import { getCurrencySymbol } from "../../util/currency"
import i18n from "../../i18n"
import Cookie from "../../util/Cookie"
import { secondsToHms } from "../../util/Utility"

import BidType from "../../components/BidType"

const ContentWrapper = styled.div`
  padding: 0px 20px;
  height: calc(60% - 65px);
`

const LiveImgWrapper = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
  height: 22px;
  margin-left: -20px;
`

const TimerWrapper = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
`

const BidInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 15px;
`

const BoldText = styled.span`
  font-size: ${(props) => `${props.size}px` || 18};
  font-family: montserratRegular;
`

const Link = styled.span`
  color: #3cb0ea;
  font-size: 14px;
  font-family: montserratRegular;
`

const ContentDescripter = styled.div`
  margin: 10px 0px;
  font-size: 13px;
  font-family: montserratLight;
  white-space: pre-line;
`

const DetailWrapper = styled.div`
  min-height: 25%;
  display: flex;
  padding-top: 15px;
  padding-bottom: 90px;
  flex-direction: column;
  overflow-y: scroll;
`

const PlaceBidButton = styled.div`
  display: flex;
  position: fixed;
  bottom: 10px;
  width: 100%;
  margin-left: -20px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const TextTitle = styled.div`
  font-size: ${(props) => `${props.size}px`};
  font-family: montserratRegular;
  margin-bottom: 5px;
`

const TimerConatiner = styled.div`
  height: 56px;
  width: 100%;
  // background-color: #ffcf86;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "montserratRegular";
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 3px;
  position: fixed;
  z-index: 9;
  max-width: 500px;
`

const ActionContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ##1c1d23;
  padding: 24px 0;
  box-sizing: border-box;
`

const ActionButton = styled.button`
  width: 128px;
  border-radius: 24px;
  border: solid 1px #ff5186;
  color: #fff;
  padding: 9px;
  background: transparent;
  font-family: "montserratLight";
  margin: 0 15px;
  cursor: pointer;
`

const FeatureBox = styled.div`
  width: 100%;
  padding: 25px 22px;
  box-sizing: border-box;
  color: #fff;
  border-radius: 4px;
  text-align: left;
  font-family: "montserratLight";
`
const FeatureTitle = styled.p`
  font-size: 16px;
  margin-top: 0;
`

const KeyFeature = styled.p`
  font-size: 11px;
`

const AvailableBids = styled.span`
  font-family: "montserratLight";
  font-size: 16px;
  color: #fff;
`

// const ImageData = [
//     { id: 5, videoUrl: "https://www.youtube.com/watch?v=zYhBJoBUSYA", type: "video"},
// 	{ id: 1, imgUrl: "../../../images/bg2.jpg", type: "image"},
// 	{ id: 2, imgUrl: "../../../images/bg4.jpg", type: "image"},
// 	{ id: 3, imgUrl: "../../../images/bg3.jpg", type: "image"},
// 	{ id: 4, imgUrl: "../../../images/bg2.jpg", type: "image"},
// ];

class ProductDetails extends React.Component {
  constructor(props) {
    super(props)
    this.loadData = this.loadData.bind(this)
    this.goToInvite = this.goToInvite.bind(this)
    this.state = {
      count: 0,
      running: false,
    }
  }

  componentDidMount() {
    this.loadData()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.running !== prevState.running) {
      switch (this.state.running) {
        case true:
          this.handleStart()
      }
    }
  }

  handleStart = (res) => {
    if (res) {
      const Data = res.auctionDetailsDTO.auction[0]
      console.log({ Data })
      this.setState({ count: parseInt(Data.offerTimeLeft), running: true })
      this.timer = setInterval(() => {
        const newCount = this.state.count - 1

        this.setState({ count: newCount >= 0 ? newCount : 0 })
      }, 1000)
    }
  }

  handleStop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.setState({ running: false })
    }
  }

  handleReset() {
    this.setState({ count: 0 })
  }

  format(d) {
    // let seconds = time % 60;
    // let minutes = Math.floor(time / 60);
    // minutes = minutes.toString().length === 1 ? "0" + minutes : minutes;
    // seconds = seconds.toString().length === 1 ? "0" + seconds : seconds;
    // return minutes + ':' + seconds;
    var h = Math.floor(d / 3600)
    var m = Math.floor((d % 3600) / 60)
    var s = Math.floor((d % 3600) % 60)

    var hDisplay = "00"
    var mDisplay = "00"
    var sDisplay = "00"

    if (h < 24) {
      if (h < 10) {
        hDisplay = h > 0 ? "0" + h : "00"
      } else {
        var hDisplay = h > 0 ? h : "00"
      }

      if (m < 10) {
        mDisplay = m > 0 ? "0" + m : "00"
      } else {
        mDisplay = m > 0 ? m : "00"
      }

      if (s < 10) {
        sDisplay = s > 0 ? "0" + s : "00"
      } else if (s > 0) {
        sDisplay = s > 0 ? s : "00"
      } else {
        sDisplay = "00"
      }

      return `${hDisplay} : ${mDisplay} : ${sDisplay}`
    } else {
      const day = Math.round(h / 24)
      const textDay = day > 1 ? `${day} Days` : `${day} Day`
      return textDay
    }
  }

  componentWillUnmount() {
    const { removeData, uniqueId } = this.props
    removeData({
      uniqueId,
    })
    this.handleStop()
  }

  loadData() {
    console.log("LOAD DATA Product")
    const { fetchData, uniqueId } = this.props
    fetchData({
      uniqueId,
      method: "GET",
      uri: `/offers`,
      params: {
        offerId: get(this.props, "match.params.offerId"),
      },
      onSuccess: (res) => {
        this.handleStart(res)
      },
    })
  }

  openBidPopup(data) {
    this.props.showPopup({
      renderComponent: () => <BidType data={data} onClick={this.placeBid} />,
      showPopup: true,
      style: {
        background: "transparent",
        boxShadow: "none",
      },
    })
  }

  placeBid = ({ bidsRemaining, offerId, offerTitle }, singleBid) => {
    const { fetchData } = this.props
    if (isUser()) {
      // http://ind.mybidwin.com/gateway/placeBid/99?bids=16.06,16.10

      if (bidsRemaining > 0) {
        if (singleBid) {
          fetchData({
            method: "POST",
            uri: `/placeBid/${offerId}`,
            withUserCredentials: true,
            params: {
              bids: singleBid.toString(),
            },
            onSuccess: (res) => {
              // console.log("placeMyBid res-->>",res)
              this.props.showPopup({})
              showToast({
                text: i18n.t("BidSubmitted"),
                variant: "success",
              })
              this.loadData()
            },
          })
        } else {
          this.props.history.push({
            pathname: `/play/place-bids/${replaceWithSymbol(
              offerTitle
            )}/${offerId}`,
            state: { bidsRemaining: bidsRemaining },
          })
          this.props.showPopup({})
          event({
            category: "Auction Details Page",
            action: "Place Bid",
          })
        }
      } else {
        this.props.showToast({
          text: i18n.t("buyBids"),
          variant: "warning",
        })
        setTimeout(() => {
          this.props.history.push({
            pathname: "/play/",
            state: { selectedIndex: 1 },
          })
        }, 1000)
        event({
          category: "Auction Details Page",
          action: i18n.t("buyBids"),
        })
      }
    } else {
      this.props.showPopup({})
      let langId = Cookie.get("X-Reycreo-Language-Id")
      
      console.log("Lang Id ", langId)

      let host = window.location.hostname
      let subDomain = host.split(".")[0]
      let SUB = `${config.NON_WIFI_OP}`
      let SEND_TO_BILLING = `${config.NO_LOGIN_OP}`
      let CG_FLOW = `${config.CG_FLOW_OP}`
      console.log("SUB : ", SUB)
      if (SUB.includes(subDomain)) {
        this.props.history.push("/play/no-data")
      } else if (SEND_TO_BILLING.includes(subDomain)) {
        let operatorId = SEND_TO_BILLING.split("_")[1]
        console.log(" operatorId : Login ", operatorId)
        Cookie.setToPath(
          "X-Reycreo-Operator-Id",
          operatorId,
          "." + host.split(".")[1] + "." + host.split(".")[0]
        )
        window.location.href = `${config.BILLING_URL}/billing`
      } else if (CG_FLOW.includes(subDomain) && langId === null) {
        console.log(" NO_LOGIN Product ", config.BILLING_URL)

        this.props.showToast({
          text: i18n.t("loginRequired"),
          variant: "warning",
        })
        setTimeout(() => {
          window.location.href = `${config.BILLING_URL}`
        }, 1000)
        event({
          category: "Auction Details Page",
          action: i18n.t("loginRequired"),
        })
      } else {
        this.props.showToast({
          text: i18n.t("loginRequired"),
          variant: "warning",
        })
        setTimeout(() => {
          window.location.href = `${config.BILLING_URL}/login`
          // this.props.history.push("/login");
        }, 1000)
        event({
          category: "Auction Details Page",
          action: i18n.t("loginRequired"),
        })
      }
    }
  }

  goToInvite() {
    console.log("goToInvite")
    this.props.history.push("/play/invite-and-earn")
    event({
      category: "Auction Details Page",
      action: "Free Bids",
    })
  }

  render() {
    let { data, theme } = this.props
    if (!data) {
      return null
    } else if (data.error) {
      return <span>{data.error}</span>
    }

    let host = window.location.hostname
    let subDomain = host.split(".")[1]
    let subStatus = Cookie.get("SubscriberStatus")
    console.log(" SUB APP ", subDomain, subStatus)
    let heightBox = 32
    let flagBuy = true
    if (subDomain === "epu") {
      heightBox = 62
    }
    if (!subStatus) {
      subStatus = "TRIAL"
    }
    if (subDomain === "epu" && subStatus === "SUBSCRIBED") {
      flagBuy = false
    } else if (subDomain === "epu") {
      flagBuy = true
    }

    const Data = get(data, "data.auctionDetailsDTO.auction[0]")
    const bidsRemaining = get(data, "data.auctionDetailsDTO.bidsRemaining", 0)
    const bannerData = get(
      data,
      "data.auctionDetailsDTO.auction[0].resources",
      []
    )
    const { count } = this.state

    if (Data == null) return null

    let convertedTimeLeft = "HH:MM:ss"
    if (Data != null) {
      convertedTimeLeft = secondsToHms(Data.offerTimeLeft)
    }
    const handleButtonClick = () => {
      if (Cookie.get("X-Reycreo-Msisdn") == null) {
        window.location.href = `${config.BILLING_URL}/login`;
      } else {
        window.location.href = `${config.BILLING_URL}/billing`;
        event({
          category: "Auction Details Page",
          action: "Buy Bids",
        });
      }
    };
    return (
      <div className='wrapper'>
        <PageHeader
          backLocation='/play/'
          label={i18n.t("Auctions")}
          freeBids={true}
          handleInvite={this.goToInvite}
          theme={theme}
        />
        <TimerConatiner
          style={{
            backgroundColor: theme.highlightBorderColor,
            color: theme.secondaryColor,
          }}
        >
          {Data.offerTimeLeft && Data.offerTotalTime ? (
            // (
            //   <ProgressBar
            //     timerData={{
            //       timeLeft: Data.offerTimeLeft,
            //       totalTime: Data.offerTotalTime,
            //     }}
            //   />
            // )
            this.format(count)
          ) : (
            // convertedTimeLeft
            <span className='montserratLight'>
              {i18n.t("AuctionNotLiveYet")}!!
            </span>
          )}
        </TimerConatiner>
        <div
          className='container_body'
          style={{ marginTop: "56px", background: theme.secondaryColor }}
        >
          {!isEmpty(bannerData) && (
            <CarouselView
              data={bannerData}
              onSelect={() => console.log("onSelect")}
              maxHeight={"40%"}
              share={false}
            />
          )}
          <ContentWrapper>
            <ActionContainer>
            <ActionButton onClick={handleButtonClick}>
              {i18n.t("BuyBids")}
              </ActionButton>

              <ActionButton
                onClick={() => {
                  this.props.history.push(
                    `/play/my-bids/${replaceWithSymbol(Data.offerTitle)}/${
                      Data.offerId
                    }`
                  )
                  event({
                    category: "Auction Details Page",
                    action: "My Bids",
                  })
                }}
              >
                {i18n.t("MyBids")}
              </ActionButton>
            </ActionContainer>
            <FeatureBox style={{ backgroundColor: theme.cardColor }}>
              <FeatureTitle>{Data.offerTitle}</FeatureTitle>
              <KeyFeature style={{ fontSize: "14px" }}>
                {i18n.t("KeyFeatures")}
              </KeyFeature>
              <KeyFeature>{Data.offerDescription}</KeyFeature>
            </FeatureBox>
            {/* <LiveImgWrapper>
              <img
                src={
                  `${config.MRBIDNWIN_S3_IMAGE_URL}/` +
                  i18n.t("live_now") +
                  `.` +
                  i18n.t("live_now_file_type")
                }
                alt='live_now'
              />
            </LiveImgWrapper> */}
            {/* <TimerWrapper>
              {Data.offerTimeLeft && Data.offerTotalTime ? (
                <ProgressBar
                  timerData={{
                    timeLeft: Data.offerTimeLeft,
                    totalTime: Data.offerTotalTime,
                  }}
                />
              ) : (
                <span className='montserratLight'>
                  Auction isn't live yet!!
                </span>
              )}
            </TimerWrapper> */}
            {/* {isUser() && (
              <BidInfoWrapper>
                <BoldText size={14}>
                  {i18n.t("Youhave")} <b>{bidsRemaining}</b> {i18n.t("bids")}
                </BoldText>
                <PrimaryButton
                  label={i18n.t("MyBids")}
                  style={{
                    width: 100,
                    height: { heightBox },
                    fontSize: 14,
                    border: "1px solid lightgrey",
                  }}
                  onClick={() => {
                    this.props.history.push(
                      `/play/my-bids/${replaceWithSymbol(Data.offerTitle)}/${Data.offerId}`
                    )
                    event({
                      category: "Auction Details Page",
                      action: "My Bids",
                    })
                  }}
                />
              </BidInfoWrapper>
            )}
            <BidInfoWrapper>
              <Link
                onClick={() => {
                  this.props.history.push({
                    pathname: "/play/how-bid-works",
                    state: {
                      offerId: Data.offerId,
                      title: replaceWithSymbol(Data.offerTitle),
                    },
                  })
                  event({
                    category: "Auction Details Page",
                    action: "How To Bid",
                  })
                }}
              >
                {i18n.t("HowToBid")}
              </Link>
              {flagBuy && (
                <PrimaryButton
                  label={i18n.t("BuyBids")}
                  style={{
                    width: 100,
                    height: { heightBox },
                    fontSize: 14,
                    border: "1px solid lightgrey",
                  }}
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/play/",
                      state: { selectedIndex: 1 },
                    })
                    event({
                      category: "Auction Details Page",
                      action: "Buy Bids",
                    })
                  }}
                />
              )}
            </BidInfoWrapper>*/}
            {/* <Divider /> */}
            <DetailWrapper>
              {/* <TextTitle size={16}>{Data.offerTitle}</TextTitle>
              <TextTitle size={16}>
                {getCurrencySymbol()}
                {Data.price}
              </TextTitle>
              <TextTitle size={14}>{i18n.t("KeyFeatures")}</TextTitle>
              <ContentDescripter>{Data.offerDescription}</ContentDescripter> */}
            </DetailWrapper>
            <PlaceBidButton
              className='setWidth'
              style={{ backgroundColor: theme.secondaryColor }}
            >
              <div style={{ margin: "20px" }}>
                <AvailableBids>{i18n.t("Youhave")}</AvailableBids>&nbsp;
                <AvailableBids style={{ fontWeight: "bold" }}>
                  {bidsRemaining}
                </AvailableBids>
                &nbsp;
                <AvailableBids>{i18n.t("Bids")}</AvailableBids>
              </div>
              <PrimaryButton
                label='StartBidding'
                variant='contained'
                style={{
                  borderRadius: "30px",
                  backgroundColor: theme.primaryButtonColor,
                  maxWidth: "280px",
                  width: "100%",
                  height: "56px",
                  textTransform: "uppercase",
                }}
                onClick={() =>
                  //   this.placeBid({
                  //     bidsRemaining,
                  //     offerId: Data.offerId,
                  //     offerTitle: Data.offerTitle,
                  //   })
                  this.openBidPopup({
                    bidsRemaining,
                    offerId: Data.offerId,
                    offerTitle: Data.offerTitle,
                  })
                }
              />
            </PlaceBidButton>
          </ContentWrapper>
        </div>
      </div>
    )
  }
}

ProductDetails = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      ;(mapStateToProps.data = state.data[ownProps.uniqueId]),
        (mapStateToProps.theme = state.theme)
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
    showToast,
    showPopup,
  }
)(ProductDetails)

export default class ProductDetailsWrapper extends React.Component {
  componentDidMount() {
    this.uuid = uuid.v4()
    const locale = Cookie.get("X-Reycreo-Language-Id")
    i18n.changeLanguage(locale || "en")
    console.log("RENDER ProductDetailsWrapper :: ", locale)
  }

  render() {
    return <ProductDetails {...this.props} uniqueId={this.uuid} />
  }
}



// WEBPACK FOOTER //
// ./src/views/ProductDetails/index.js